import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "fixed top-0 flex left-0 w-screen p-2 justify-between z-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = { class: "flex justify-items-end items-center" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "font-bold leading-none text-gray-900" }
const _hoisted_8 = { class: "text-gray-600" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "person", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "settings", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "logout", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fr_list_item = _resolveComponent("fr-list-item")!
  const _component_fr_list = _resolveComponent("fr-list")!
  const _component_fr_dropdown = _resolveComponent("fr-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_fr_dropdown, {
        class: "ml-4",
        "options-width": "250px",
        align: "right"
      }, {
        default: _withCtx(({ handleClick }) => [
          ($setup.currentUser)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "flex p-2 rounded-full justify-end items-center rounded transition-colors duration-300 easin-out flex-nowrap hover:bg-gray-900 hover:bg-opacity-20",
                onClick: handleClick
              }, [
                _createElementVNode("img", {
                  src: 
                $setup.currentUser.profile_image_url
                  ? $setup.currentUser.profile_image_url
                  : `https://ui-avatars.com/api/?name=${$setup.currentUser.name}`
              ,
                  width: "40",
                  height: "40",
                  alt: "",
                  class: "rounded-full mr-3"
                }, null, 8, _hoisted_5),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString($setup.currentUser.name), 1),
                  _createElementVNode("small", _hoisted_8, _toDisplayString($setup.currentUser.code), 1)
                ])
              ], 8, _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        options: _withCtx(() => [
          _createVNode(_component_fr_list, {
            hoverable: "",
            bordered: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_fr_list_item, null, {
                avatar: _withCtx(() => [
                  _hoisted_9
                ]),
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "#",
                    class: "text-gray-600",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.logout && $setup.logout(...args)))
                  }, _toDisplayString(_ctx.$t('navbar.my_profile_text')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_fr_list_item, null, {
                avatar: _withCtx(() => [
                  _hoisted_10
                ]),
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "#",
                    class: "text-gray-600",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.logout && $setup.logout(...args)))
                  }, _toDisplayString(_ctx.$t('navbar.settings_text')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_fr_list_item, null, {
                avatar: _withCtx(() => [
                  _hoisted_11
                ]),
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "#",
                    class: "text-gray-600",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.logout && $setup.logout(...args)))
                  }, _toDisplayString(_ctx.$t('navbar.log_out_text')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}